module.exports = "<ng-select2 [data]=\"filterTypes\" [width]=\"300\" [options]=\"select2Opts\" (valueChanged)=\"onValueChanged($event)\"></ng-select2>\n"